import script from "./modalDeConfirmacao.vue?vue&type=script&setup=true&lang=js"
export * from "./modalDeConfirmacao.vue?vue&type=script&setup=true&lang=js"

import "./modalDeConfirmacao.vue?vue&type=style&index=0&id=58c5b2b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c5b2b2"]])

export default __exports__